import { render, staticRenderFns } from "./EditStoryReply.vue?vue&type=template&id=b446de74&"
import script from "./EditStoryReply.vue?vue&type=script&lang=js&"
export * from "./EditStoryReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports